(() => {
  customElements.whenDefined('royal-configurator').then(() => {
    class MultiPetPortrait extends customElements.get('royal-configurator') {
      connectedCallback() {
        if (this.started) return;
        this.nativeIntro = true;
        this.nativeFamily = this.querySelector('[data-royal-slide="0"]')?.dataset.nativePet;
        super.connectedCallback();
        const signal = this.controller.signal;
        // Capture intent before the base configurator resolves the selected native variant.
        this.addEventListener('change', event => {
          if (event.target.matches('[data-option]')) this.nativeIntro = false;
        }, {capture: true, signal});
        this.addEventListener('click', event => {
          if (event.target.matches('[data-option="1"]')) {
            this.nativeIntro = false;
            this.nativeSelection = null;
            this.updateArt();
          }
        }, {capture: true, signal});
      }
      updateArt() {
        if (this.nativeIntro) return;
        const background = this.selectedOptions()[0];
        const frame = this.digitalOnly || this.frame === 'Poster-Only' ? 'No frame' : this.frame;
        const key = `${this.nativeFamily}|${background}|${frame}`;
        if (key === this.nativeSelection) return;
        this.nativeSelection = key;
        const index = (this.gallerySlides || [...this.querySelectorAll('[data-royal-slide]')]).findIndex(slide =>
          slide.dataset.nativePet === this.nativeFamily &&
          slide.dataset.nativeBackground === background && slide.dataset.nativeFrame === frame);
        if (index >= 0) this.selectGallery(index);
      }
      setFraming(mode) {
        this.nativeIntro = false;
        super.setFraming(mode);
      }
      selectGallery(index) {
        const slides=this.gallerySlides || [...this.querySelectorAll('[data-royal-slide]')];
        const next=(index+slides.length)%slides.length;
        if(next===this.visibleGalleryIndex){super.selectGallery(index);return;}
        const thumbs=this.querySelector('.royal-gallery-thumbs'),active=this.galleryButtons?.[next];
        const left=active&&thumbs?active.offsetLeft-thumbs.offsetLeft-(thumbs.clientWidth-active.offsetWidth)/2:null;
        super.selectGallery(index);
        this.nativeFamily=slides[this.galleryIndex]?.dataset.nativePet || this.nativeFamily;
        const count=this.querySelector('[data-native-gallery-count]');
        if(count)count.textContent=`${this.galleryIndex+1} / ${slides.length}`;
        if(left!==null)thumbs.scrollTo({left,behavior:'smooth'});
      }
      zoom() {
        const photo = this.querySelector(`[data-royal-slide="${this.galleryIndex}"] .fp-native-photo`);
        if (!photo) return;
        const enlarged = photo.cloneNode(true);
        enlarged.className = 'fp-native-zoom-photo'; enlarged.loading = 'eager'; enlarged.sizes = '90vw';
        this.openInfo('Portrait preview', enlarged);
      }
    }
    if (!customElements.get('fp-multi-portrait')) customElements.define('fp-multi-portrait', MultiPetPortrait);
  });
})();
